import React from "react";

interface ExportOption {
  label: string;
  iconClass: string;
  onClick?: () => void; // can be undefined when disabled
  colorClass?: string;
}

interface ExportProps {
  options: ExportOption[];
  title?: string;
  className?: string;
}

const Export: React.FC<ExportProps> = ({
  options,
  title = "Export",
  className = "",
}) => {
  // Inline spinner style
  const spinnerStyle: React.CSSProperties = {
    display: "inline-block",
    animation: "spin 1s linear infinite",
  };

  const keyframes = `
    @keyframes spin {
      100% { transform: rotate(360deg); }
    }
  `;

  // Inject keyframes into document (once)
  if (typeof document !== "undefined" && !document.getElementById("export-spinner-style")) {
    const style = document.createElement("style");
    style.id = "export-spinner-style";
    style.innerHTML = keyframes;
    document.head.appendChild(style);
  }

  if (options.length === 1) {
    const opt = options[0];
    const isDisabled = !opt.onClick;

    return (
      <button
        type="button"
        className={`btn btn-outline-primary ${className}`}
        onClick={opt.onClick}
        disabled={isDisabled}
      >
        <i
          className={`${opt.iconClass} me-2 ${opt.colorClass ?? ""}`}
          style={opt.iconClass.includes("ti-loader") ? spinnerStyle : {}}
        />
        {opt.label}
      </button>
    );
  }

  return (
    <div className={`dropdown ${className}`}>
      <button
        className="btn btn-outline-primary dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i className="ti ti-package-export me-2" />
        {title}
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        {options.map((opt, idx) => (
          <li key={idx}>
            <button
              type="button"
              className="dropdown-item d-flex align-items-center gap-2"
              onClick={opt.onClick}
              disabled={!opt.onClick}
            >
              <i
                className={`${opt.iconClass} ${opt.colorClass ?? ""}`}
                style={opt.iconClass.includes("ti-loader") ? spinnerStyle : {}}
              />
              {opt.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Export;
